module.exports = __webpack_public_path__ + "img/dashboard_analytics.8cd330fc.png";